import type { ReactNode } from 'react';

export const symbol_airline_seat_individual_suite: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M860-280H100q-24.75 0-42.37-17.63Q40-315.25 40-340v-280q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v280h353v-250q0-24.75 17.63-42.38Q488.25-650 513-650h262q59.81 0 102.41 42.59Q920-564.81 920-505v165q0 24.75-17.62 42.37Q884.75-280 860-280Zm-347-60h347v-165q0-35.06-24.97-60.03T775-590H513v250Zm0-250v250-250ZM345.5-429.5Q376-460 376-505t-30.5-75.5Q315-611 270-611t-75.5 30.5Q164-550 164-505t30.5 75.5Q225-399 270-399t75.5-30.5Zm-108-43Q224-486 224-505t13.5-32.5Q251-551 270-551t32.5 13.5Q316-524 316-505t-13.5 32.5Q289-459 270-459t-32.5-13.5ZM270-505Z"
		/>
	</svg>
);
